export const DEFAULT_CUSTOMER_ID = '-1';
